function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.75 1H2.24999C1.561 1 1 1.561 1 2.25002V7.75002C1 8.43902 1.561 9.00002 2.24999 9.00002H11.75C12.439 9.00002 13 8.43902 13 7.75002V2.25002C13 1.561 12.439 1 11.75 1ZM12.5 7.75C12.5 8.16351 12.1635 8.5 11.75 8.5H2.24999C1.83648 8.5 1.49999 8.16351 1.49999 7.75V2.25002C1.49999 1.83651 1.83648 1.50002 2.24999 1.50002H11.75C12.1635 1.50002 12.5 1.83651 12.5 2.25002V7.75H12.5Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.75 2.5H1.25001C1.11201 2.5 1 2.61201 1 2.75001V4.25001C1 4.38801 1.11201 4.50002 1.25001 4.50002H12.75C12.888 4.50002 13 4.38801 13 4.25001V2.75001C13 2.61201 12.888 2.5 12.75 2.5ZM12.5 4H1.49999V2.99999H12.5V4H12.5Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.75001 6H2.75001C2.61201 6 2.5 6.11201 2.5 6.25001C2.5 6.38801 2.61201 6.49999 2.75001 6.49999H5.75001C5.88801 6.49999 6.00002 6.38798 6.00002 6.24998C6.00002 6.11198 5.88801 6 5.75001 6Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.75001 7H2.75001C2.61201 7 2.5 7.11201 2.5 7.25001C2.5 7.38801 2.61201 7.50002 2.75001 7.50002H5.75001C5.88801 7.50002 6.00002 7.38801 6.00002 7.25001C5.99999 7.11201 5.88801 7 5.75001 7Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.75 5.5H10.25C9.83649 5.5 9.5 5.83649 9.5 6.25V6.74999C9.5 7.1635 9.83649 7.49999 10.25 7.49999H10.75C11.1635 7.49999 11.5 7.1635 11.5 6.74999V6.25C11.5 5.83652 11.1635 5.5 10.75 5.5ZM11 6.75002C11 6.88802 10.888 7.00002 10.75 7.00002H10.25C10.112 7.00002 9.99999 6.88802 9.99999 6.75002V6.25002C9.99999 6.11202 10.112 6.00002 10.25 6.00002H10.75C10.888 6.00002 11 6.11202 11 6.25002V6.75002Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
});

function SvgPmicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmicon);
export default __webpack_public_path__ + "static/media/pm.icon.a07c5c7b.svg";
export { ForwardRef as ReactComponent };